/* NewEden2.0 — facets.js
   <facet-filters>: submits filter/sort changes via fetch, swaps the product
   grid + active-filter list without a full reload, updates the URL. */
(function () {
  'use strict';

  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', class extends HTMLElement {
      constructor() {
        super();
        this.section = this.dataset.section;
        this.form = this.querySelector('form');
        this.debounced = debounce(this.applyFilters.bind(this), 400);
        if (this.form) {
          this.form.addEventListener('input', (e) => {
            if (e.target.type === 'number') this.debounced();
            else this.applyFilters();
          });
        }
        document.addEventListener('click', this.onClick.bind(this));
      }

      onClick(e) {
        var clear = e.target.closest('[data-clear-filter]');
        if (clear) { e.preventDefault(); this.applyFilters(clear.getAttribute('href')); }
        var sort = e.target.closest('[data-sort-option]');
        if (sort) { e.preventDefault(); this.applySort(sort.getAttribute('data-sort-option')); }
      }

      applySort(value) {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', value);
        this.applyFilters('?' + params.toString());
      }

      applyFilters(explicitUrl) {
        var url;
        if (explicitUrl) {
          url = explicitUrl;
        } else {
          var fd = new FormData(this.form);
          var params = new URLSearchParams();
          fd.forEach(function (v, k) { if (v) params.append(k, v); });
          var existing = new URLSearchParams(window.location.search);
          if (existing.get('sort_by')) params.set('sort_by', existing.get('sort_by'));
          url = window.location.pathname + '?' + params.toString();
        }
        this.renderFromUrl(url);
      }

      renderFromUrl(url) {
        document.body.classList.add('facets-loading');
        var sep = url.indexOf('?') > -1 ? '&' : '?';
        fetch(url + sep + 'section_id=' + this.section, { headers: { Accept: 'text/html' } })
          .then((r) => r.text())
          .then((html) => {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            ['[data-product-grid]', '[data-facets-wrapper]', '[data-collection-toolbar]', '[data-pagination]'].forEach(function (sel) {
              var fresh = doc.querySelector(sel);
              var current = document.querySelector(sel);
              if (fresh && current) current.innerHTML = fresh.innerHTML;
            });
            window.history.pushState({}, '', url);
          })
          .finally(function () { document.body.classList.remove('facets-loading'); });
      }
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  window.addEventListener('popstate', function () {
    var ff = document.querySelector('facet-filters');
    if (ff) ff.renderFromUrl(window.location.pathname + window.location.search);
  });
})();
